import axios from 'axios'
import { protocol, origin } from './addons'

export const getChart = (data, type, chartType, country) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios({ method: 'post',
          url: `${protocol}//${origin}/api/chart`,
          data: {
            data,
            type,
            chartType,
            country
          },
          responseType: 'blob' })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            let fileName = data.title
            link.setAttribute('download', `${fileName}.pdf`)
            document.body.appendChild(link)
            link.click()
            dispatch(response)
            resolve()
          })
          .catch((error) => {
            console.log(error)
            resolve()
          })
      })
    }
  }

const ACTION_HANDLERS = {}
const initialState = {}

export default function chartReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/charts.js